module.exports = __webpack_public_path__ + "img/Poker_Chip_Red.687da5fa.svg";